import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PricingService } from './pricing.service';
import {AccountType, SubscriptionPlan} from '@ee/common/enums';
import { Observable } from 'rxjs';
import { ProductResponse } from './models/product-reponse.model';
import { Product } from './models/product.model';
import { Price } from './models/price.model';

@Component({
  selector: 'ee-pricing-table',
  template: `
    <div class="pricing-table-wrapper">
      @if ((products$ | async); as products) {
        <div class="term">
          <span class="billed-monthly-label" [ngClass]="{'font-semibold': selectedTerm === 'monthly'}">Billed Monthly</span>
          <ng-toggle [(ngModel)]="selectedTerm" (ngModelChange)="updateTerm()" [height]="19" [color]="toggleColors" [values]="toggleValues"></ng-toggle>
          <span class="billed-annually-label" [ngClass]="{'font-semibold': selectedTerm === 'annual'}">
            Billed Annually @if (products.annual_savings_text) { <span class="save">{{ products.annual_savings_text }}</span> }</span>
        </div>
        <div class="pricing-table">
          @for (product of products.products; track product.id; let index = $index) {
            @if (hidePlan !== index) {
              <ee-product [product]="product" [term]="selectedTerm" (selectPlan)="selectPlan.emit($event)"
              [actionButtonOverride]="actionButtonOverride" [currentPlan]="currentPlan" [currentProductId]="currentProductId"></ee-product>
            }
          }
        </div>
      }
    </div>
    `,
  styleUrls: ['./_pricing-common.scss', './pricing-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PricingTableComponent implements OnInit {
  @Input({ required: true }) type: AccountType;
  @Input({ required: false }) hidePlan: number | null = null;
  @Input({ required: false }) actionButtonOverride: string | null = null;
  @Input({ required: false }) currentPlan: SubscriptionPlan | null = null;
  @Input({ required: false }) currentProductId: string | null = null;
  @Output() selectPlan = new EventEmitter<{ product: Product; price: Price }>();

  public products$: Observable<ProductResponse>;
  public toggleColors = {
    unchecked: '#d50000',
    checked: '#d50000'
  };
  public toggleValues = {
    unchecked: 'monthly',
    checked: 'annual'
  };
  selectedTerm: 'annual' | 'monthly' = 'annual';

  constructor(private pricingService: PricingService) {}

  ngOnInit(): void {
    this.products$ = this.pricingService.getProducts(this.type);
  }

  updateTerm(): void {
    this.pricingService.updateTerm(this.selectedTerm);
  }
}
